// import React, { useState, useEffect, useMemo } from "react";
// // 1. Redux Imports
// import { useDispatch, useSelector } from "react-redux";
// import { createUserApis, usersApis } from "../redux/users/userActions";
// import { selectUsers, selectUsersStatus } from "../redux/users/userSelectors";
// import { toast } from "react-toastify";
// // Component Imports
// import Table from "../components/Table";
// import Modal from "../components/Modal";
// import TextInput from "../components/TextInput";
// import SelectInput from "../components/SelectInput";
// import Loader from "../components/Loader";
// import "../assets/css/modal.css";

// const User = () => {
//   const [showModal, setShowModal] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(100);

//   const dispatch = useDispatch();
//   const usersData = useSelector(selectUsers);
//   const status = useSelector(selectUsersStatus);

//   const totalRecords = useMemo(() => {
//     return usersData?.totalRecords || usersData?.data?.totalRecords || 0;
//   }, [usersData]);

//   useEffect(() => {
//     dispatch(usersApis({ currentPage: currentPage, pageSize }));
//   }, [dispatch, currentPage, pageSize]);

//   const [formData, setFormData] = useState({
//     userName: "",
//     lastName: "",
//     email: "",
//     role: "Viewer",
//   });
//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//     if (errors[name]) setErrors({ ...errors, [name]: "" });
//   };

//   const validateForm = () => {
//     let newErrors = {};
//     let isValid = true;
//     if (!formData.userName.trim()) {
//       newErrors.userName = "User Name required";
//       isValid = false;
//     }
//     if (!formData.email.trim()) {
//       newErrors.email = "Email required";
//       isValid = false;
//     }
//     setErrors(newErrors);
//     return isValid;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     setIsLoading(true);
//     const apiPayload = {
//       userName: formData.userName,
//       lastName: formData.lastName,
//       email: formData.email,
//       role: formData.role || null,
//     };

//     const result = await dispatch(createUserApis(apiPayload));

//     if (createUserApis.fulfilled.match(result)) {
//       toast.success("New User Created Successfully!");
//       setShowModal(false);
//       setFormData({ userName: "", lastName: "", email: "", role: "Viewer" });
//       dispatch(usersApis({ currentPage: currentPage, pageSize }));
//     }
//     setIsLoading(false);
//   };

//   // --- 1. NEW ROLE BADGE HANDLER ---
//   const getRoleBadge = (role) => {
//     const roleKey = role?.toUpperCase() || "USER";

//     // Define color mappings for each role
//     const roleStyles = {
//       SUPER_ADMIN: { bg: "#F3E8FF", text: "#7E22CE", border: "#D8B4FE" }, // Purple
//       ADMIN: { bg: "#E0F2FE", text: "#0369A1", border: "#7DD3FC" }, // Blue
//       EDITOR: { bg: "#FEF3C7", text: "#B45309", border: "#FCD34D" }, // Amber
//       VIEWER: { bg: "#F3F4F6", text: "#374151", border: "#D1D5DB" }, // Gray
//       USER: { bg: "#DCFCE7", text: "#15803D", border: "#86EFAC" }, // Green
//     };

//     const style = roleStyles[roleKey] || roleStyles.USER;

//     const badgeStyle = {
//       padding: "4px 10px",
//       borderRadius: "6px",
//       fontSize: "11px",
//       fontWeight: "700",
//       display: "inline-block",
//       textAlign: "center",
//       minWidth: "90px",
//       backgroundColor: style.bg,
//       color: style.text,
//       border: `1px solid ${style.border}`,
//       letterSpacing: "0.5px",
//     };

//     return <span style={badgeStyle}>{roleKey.replace("_", " ")}</span>;
//   };

//   const getStatusBadge = (statusValue) => {
//     const isActive = statusValue === true;
//     const badgeStyle = {
//       padding: "4px 12px",
//       borderRadius: "12px",
//       fontSize: "12px",
//       fontWeight: "bold",
//       display: "inline-block",
//       textAlign: "center",
//       minWidth: "80px",
//       backgroundColor: isActive ? "#EBF5FF" : "#FEE2E2",
//       color: isActive ? "#007BFF" : "#DC3545",
//       border: isActive ? "1px solid #007BFF" : "1px solid #DC3545",
//     };
//     return <span style={badgeStyle}>{isActive ? "Active" : "Inactive"}</span>;
//   };

//   const userColumns = [
//     // { header: "User ID", accessor: "UserCode" },
//     {
//       header: "Email Address",
//       accessor: "EMail",
//       // --- FIX: Wrap email text and set a max width if needed ---
//       render: (row) => (
//         <div
//           style={{
//             wordBreak: "break-all",
//             whiteSpace: "normal",
//             maxWidth: "250px",
//             lineHeight: "1.2",
//           }}
//         >
//           {row.EMail}
//         </div>
//       ),
//     },
//     { header: "User Name", accessor: "UserName" },

//     {
//       header: "Role",
//       accessor: "Role",
//       render: (row) => getRoleBadge(row.Role),
//     },
//     {
//       header: "Status",
//       accessor: "Status",
//       render: (row) => getStatusBadge(row.Status),
//     },
//   ];

//   return (
//     <div
//       className="p-4"
//       style={{ backgroundColor: "#F4F7FE", minHeight: "100vh" }}
//     >
//       {(status === "loading" || isLoading) && <Loader isLoading={true} />}

//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <h5 className="fw-bold text-dark m-0">User Management</h5>
//         <button
//           className="btn btn-primary-custom-model px-4 py-2"
//           onClick={() => setShowModal(true)}
//         >
//           + Add User
//         </button>
//       </div>

//       <Table
//         columns={userColumns}
//         data={usersData?.data?.data || usersData} // Handles different API response structures
//         totalCount={totalRecords}
//         currentPage={currentPage}
//         pageSize={pageSize}
//         onPageChange={setCurrentPage}
//         onPageSizeChange={(size) => {
//           setPageSize(size);
//           setCurrentPage(1);
//         }}
//         isLoading={status === "loading"}
//       />

//       <Modal
//         show={showModal}
//         onClose={() => setShowModal(false)}
//         title="Add New User"
//       >
//         <form onSubmit={handleSubmit}>
//           <TextInput
//             width="100%"
//             label="User Name"
//             name="userName"
//             placeholder="John"
//             value={formData.userName}
//             onChange={handleChange}
//             error={errors.userName}
//             required
//             autoFocus
//           />
//           <TextInput
//             width="100%"
//             label="Email Address"
//             name="email"
//             placeholder="name@example.com"
//             value={formData.email}
//             onChange={handleChange}
//             error={errors.email}
//             required
//           />
//           <SelectInput
//             width="100%"
//             label="Assign Role"
//             name="role"
//             value={formData.role}
//             onChange={handleChange}
//             required
//             options={[
//               { value: "SUPER_ADMIN", label: "Super Admin" },
//               { value: "ADMIN", label: "Admin" },
//               { value: "USER", label: "User" },
//               { value: "VIEWER", label: "Viewer" },
//               { value: "EDITOR", label: "Editor" },
//             ]}
//             maxHeight="150px"
//           />

//           <div className="d-flex justify-content-end gap-2 mt-3">
//             <button
//               type="button"
//               className="btn-light-custom"
//               onClick={() => setShowModal(false)}
//             >
//               Cancel
//             </button>
//             <button type="submit" className="btn-primary-custom-model">
//               Create User
//             </button>
//           </div>
//         </form>
//       </Modal>
//     </div>
//   );
// };

// export default User;


import React, { useState, useEffect, useMemo, useRef } from "react";
// 1. Redux Imports
import { useDispatch, useSelector } from "react-redux";
import { createUserApis, usersApis } from "../redux/users/userActions";
import { selectUsers, selectUsersStatus } from "../redux/users/userSelectors";
import { toast } from "react-toastify";
// Component Imports
import Table from "../components/Table";
import Modal from "../components/Modal";
import TextInput from "../components/TextInput";
import SelectInput from "../components/SelectInput";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import "../assets/css/modal.css";

// --- Team routing ---
import TeamPicker from "../components/TeamPicker";
import TeamBadge from "../components/TeamBadge";
import { teamListApis, setUserTeamsApis } from "../redux/team/teamActions";
import { selectTeams } from "../redux/team/teamSelectors";

/* A super admin holds every team through their role, so ticking teams for one
   does nothing. Saying so is better than showing a picker that has no effect. */
const ROLE_SEES_ALL = "SUPER_ADMIN";

const User = () => {
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);

  // Editing an existing person's teams, opened from the Teams column.
  const [teamEditUser, setTeamEditUser] = useState(null);
  const [editTeamCodes, setEditTeamCodes] = useState([]);
  const [editPrimaryTeam, setEditPrimaryTeam] = useState("");

  const dispatch = useDispatch();
  const usersData = useSelector(selectUsers);
  const status = useSelector(selectUsersStatus);
  const teamList = useSelector(selectTeams);

  console.log(usersData);
  console.log(usersData?.data);
  console.log(usersData?.data?.data);
  // --- FIX: Prevent Double API Calls ---
  // const lastFetchedParams = useRef(null);

  const totalRecords = useMemo(() => {
    return usersData?.data?.totalRecords || 0;
  }, [usersData]);

  // useEffect(() => {
  //   const currentParams = { currentPage, pageSize };

  //   // Check if we already fetched these exact params
  //   if (
  //     lastFetchedParams.current &&
  //     lastFetchedParams.current.currentPage === currentPage &&
  //     lastFetchedParams.current.pageSize === pageSize
  //   ) {
  //     return; // Skip duplicate call
  //   }

  //   // Update ref and fetch
  //   lastFetchedParams.current = currentParams;
  //   dispatch(usersApis(currentParams));
  // }, [dispatch, currentPage, pageSize]);
  // // -------------------------------------
useEffect(() => {
  dispatch(
    usersApis({
      currentPage,
      pageSize,
    })
  );
}, [dispatch, currentPage, pageSize]);

  useEffect(() => {
    dispatch(teamListApis({}));
  }, [dispatch]);

  const initialFormState = {
    userName: "",
    lastName: "",
    email: "",
    role: "Viewer",
    teamCodes: [],
    primaryTeamCode: "",
  };
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  const teams = useMemo(
    () => (Array.isArray(teamList) ? teamList : teamList?.data || []),
    [teamList],
  );

  const seesAllTeams = formData.role === ROLE_SEES_ALL;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    let newErrors = {};
    let isValid = true;
    if (!formData.userName.trim()) {
      newErrors.userName = "User Name required";
      isValid = false;
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email required";
      isValid = false;
    }
    /* Creating somebody with no team creates an account that can see nothing
       — which reads as a broken login rather than a missing setting. Super
       admins are exempt: their role already grants every team. */
    if (!seesAllTeams && formData.teamCodes.length === 0) {
      newErrors.teamCodes = "Pick at least one team";
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    const apiPayload = {
      userName: formData.userName,
      lastName: formData.lastName,
      email: formData.email,
      role: formData.role || null,
      // Written with the user in one call, so the account is never briefly
      // teamless. A super admin gets none — the role covers it.
      teamCodes: seesAllTeams ? [] : formData.teamCodes,
      primaryTeamCode: seesAllTeams ? null : formData.primaryTeamCode || null,
    };

    const result = await dispatch(createUserApis(apiPayload));

    if (createUserApis.fulfilled.match(result)) {
      toast.success("New User Created Successfully!");
      setShowModal(false);
      setFormData(initialFormState);

      // Force a refresh even if params haven't changed (because we added data)
      dispatch(usersApis({ currentPage: currentPage, pageSize }));
    }
    setIsLoading(false);
  };

  const openTeamEditor = (row) => {
    setTeamEditUser(row);
    setEditTeamCodes(
      // The list endpoint sends the codes as a CSV so the grid needs no
      // second request per row.
      String(row.TeamCodes || "")
        .split(",")
        .map((code) => Number(code))
        .filter((code) => Number.isInteger(code) && code > 0),
    );
    setEditPrimaryTeam(row.PrimaryTeamCode || "");
  };

  const handleTeamEditSave = async () => {
    if (!teamEditUser) return;

    setIsLoading(true);
    const result = await dispatch(
      setUserTeamsApis({
        userCode: teamEditUser.UserCode,
        teamCodes: editTeamCodes,
        primaryTeamCode: editPrimaryTeam || null,
      }),
    );

    if (setUserTeamsApis.fulfilled.match(result)) {
      toast.success(`Teams updated for ${teamEditUser.UserName}.`);
      setTeamEditUser(null);
      dispatch(usersApis({ currentPage, pageSize }));
    }
    setIsLoading(false);
  };

  // --- ROLE BADGE HANDLER ---
  const getRoleBadge = (role) => {
    const roleKey = role?.toUpperCase() || "USER";

    const roleStyles = {
      SUPER_ADMIN: { bg: "#F3E8FF", text: "#7E22CE", border: "#D8B4FE" }, // Purple
      ADMIN: { bg: "#E0F2FE", text: "#0369A1", border: "#7DD3FC" }, // Blue
      EDITOR: { bg: "#FEF3C7", text: "#B45309", border: "#FCD34D" }, // Amber
      VIEWER: { bg: "#F3F4F6", text: "#374151", border: "#D1D5DB" }, // Gray
      USER: { bg: "#DCFCE7", text: "#15803D", border: "#86EFAC" }, // Green
    };

    const style = roleStyles[roleKey] || roleStyles.USER;

    const badgeStyle = {
      padding: "4px 10px",
      borderRadius: "6px",
      fontSize: "11px",
      fontWeight: "700",
      display: "inline-block",
      textAlign: "center",
      minWidth: "90px",
      backgroundColor: style.bg,
      color: style.text,
      border: `1px solid ${style.border}`,
      letterSpacing: "0.5px",
    };

    return <span style={badgeStyle}>{roleKey.replace("_", " ")}</span>;
  };

  const getStatusBadge = (statusValue) => {
    const isActive = statusValue === true;
    const badgeStyle = {
      padding: "4px 12px",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: "bold",
      display: "inline-block",
      textAlign: "center",
      minWidth: "80px",
      backgroundColor: isActive ? "#EBF5FF" : "#FEE2E2",
      color: isActive ? "#007BFF" : "#DC3545",
      border: isActive ? "1px solid #007BFF" : "1px solid #DC3545",
    };
    return <span style={badgeStyle}>{isActive ? "Active" : "Inactive"}</span>;
  };

  const userColumns = [
    {
      header: "Email Address",
      accessor: "EMail",
      render: (row) => (
        <div
          style={{
            wordBreak: "break-all",
            whiteSpace: "normal",
            maxWidth: "250px",
            lineHeight: "1.2",
          }}
        >
          {row.EMail}
        </div>
      ),
    },
    { header: "User Name", accessor: "UserName" },
    {
      header: "Role",
      accessor: "Role",
      render: (row) => getRoleBadge(row.Role),
    },
    {
      header: "Teams",
      accessor: "Teams",
      render: (row) => {
        // A super admin holds every team through their role, not through
        // membership rows — showing "No team" for them would be a lie.
        if (row.Role === ROLE_SEES_ALL) {
          return (
            <span className="text-muted small fst-italic">All teams</span>
          );
        }

        const names = String(row.Teams || "")
          .split(",")
          .map((n) => n.trim())
          .filter(Boolean);

        return (
          <div
            className="d-flex flex-wrap gap-1 align-items-center"
            role="button"
            title="Click to change this person's teams"
            onClick={() => openTeamEditor(row)}
            style={{ cursor: "pointer" }}
          >
            {names.length ? (
              names.map((n) => <TeamBadge key={n} name={n} />)
            ) : (
              <TeamBadge />
            )}
            <i className="bi bi-pencil text-muted small ms-1" />
          </div>
        );
      },
    },
    {
      header: "Status",
      accessor: "Status",
      render: (row) => getStatusBadge(row.Status),
    },
  ];

  return (
    <div
      className="p-4"
      style={{ backgroundColor: "#F4F7FE", minHeight: "100vh", marginTop: "55px" }}
    >
      {/* {(status === "loading" || isLoading) && <Loader isLoading={true} />} */}

      {/* <div className="d-flex justify-content-between align-items-center mb-4">
        <h5 className="report-title">User Management</h5>
        <button
          className="btn btn-primary-custom-model px-4 py-2"
          onClick={() => setShowModal(true)}
        >
          + New
        </button>
      </div> */}
      <PageHeader
        icon={<i className="bi bi-person-badge"></i>}
        title="User Management"
        subtitle="Manage users, roles and permissions"
        actions={
          <div className="d-flex align-items-center"
            // style={{ marginRight: "-80px" }}
            >

            <button
              className="btn btn-primary-custom-model"
              onClick={() => setShowModal(true)}
            >
              + New
            </button>

          </div>
        }
      />
      <Table
        columns={userColumns}
        data={usersData?.data || []}
        totalCount={usersData?.totalRecords || 0}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={setCurrentPage}
        onPageSizeChange={(size) => {
          setPageSize(size);
          setCurrentPage(1);
        }}
        isLoading={status === "loading"}
      />
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        title="Add New User"
      >
        <form onSubmit={handleSubmit}>
          <TextInput
            width="100%"
            label="User Name"
            name="userName"
            placeholder="John"
            value={formData.userName}
            onChange={handleChange}
            error={errors.userName}
            required
            autoFocus
          />
          <TextInput
            width="100%"
            label="Email Address"
            name="email"
            placeholder="name@example.com"
            value={formData.email}
            onChange={handleChange}
            error={errors.email}
            required
          />
          <SelectInput
            width="100%"
            label="Assign Role"
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
            options={[
              { value: "SUPER_ADMIN", label: "Super Admin" },
              { value: "ADMIN", label: "Admin" },
              { value: "USER", label: "User" },
              { value: "VIEWER", label: "Viewer" },
              { value: "EDITOR", label: "Editor" },
            ]}
            maxHeight="150px"
          />

          <TeamPicker
            teams={teams}
            value={formData.teamCodes}
            onChange={(codes) => {
              setFormData((prev) => ({ ...prev, teamCodes: codes }));
              if (errors.teamCodes) setErrors({ ...errors, teamCodes: "" });
            }}
            primary={formData.primaryTeamCode}
            onPrimaryChange={(code) =>
              setFormData((prev) => ({ ...prev, primaryTeamCode: code }))
            }
            disabled={seesAllTeams}
            note={
              seesAllTeams
                ? "Super admins see every team, so there is nothing to pick here."
                : undefined
            }
            error={errors.teamCodes}
          />

          <div className="d-flex justify-content-end gap-2 mt-3">
            <button
              type="button"
              className="btn-light-custom"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn-primary-custom-model">
              Create User
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        show={Boolean(teamEditUser)}
        onClose={() => setTeamEditUser(null)}
        title={`Teams — ${teamEditUser?.UserName || ""}`}
        maxWidth="520px"
      >
        <div className="p-1">
          <TeamPicker
            teams={teams}
            value={editTeamCodes}
            onChange={setEditTeamCodes}
            primary={editPrimaryTeam}
            onPrimaryChange={setEditPrimaryTeam}
          />

          {editTeamCodes.length === 0 && (
            <div className="alert alert-warning py-2 small">
              <i className="bi bi-exclamation-triangle me-1" />
              With no team, {teamEditUser?.UserName || "this person"} will not
              be able to see any task or be assigned one.
            </div>
          )}

          <div className="d-flex justify-content-end gap-2 mt-3">
            <button
              type="button"
              className="btn-light-custom"
              onClick={() => setTeamEditUser(null)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn-primary-custom-model"
              onClick={handleTeamEditSave}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save Teams"}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default User;